(function () {
    PortalList.$inject = ['$scope', '$http', '$location', 'toastr', '__env', 'readCookie'];



    angular
        .module('app')
        .component('portalListComponent', {
            templateUrl: 'modules/selection/components/portalList/portalList.html',
            controller: PortalList
        });

    function PortalList($scope, $http, $location, toastr, __env, readCookie) {

        $scope.pageTitle = 'Portal Selection';

        $scope.filterPortals = function (e) {
            if ($scope.portalFilter == '' || $scope.portalFilter === undefined) {
                $scope.portalSource.filter([]);
            } else {
                $scope.portalSource.filter({ 'field': 'portalName', 'operator': 'startswith', 'value': $scope.portalFilter });
            }

        };

        $scope.navToPortal = function () {
            location.href = this.dataItem.baseUri;
        };

        // kendo data source for the Portal Grid
        $scope.portalSource = new kendo.data.DataSource({
            type: 'aspnetmvc-ajax',
            transport: {
                read: {
                    type: 'get',
                    contentType: 'application/json',
                    url: __env.apiLogin + 'session/' + readCookie.getByName(__env.sessionCookieName),
                    beforeSend: function (req) {
                        req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
                        req.setRequestHeader('Authorization', 'Bearer ' + readCookie.getByName(__env.authCookieName));
                    },
                },
                parameterMap: function (options, operation) {

                    if (operation == 'read') {
                        return JSON.stringify(options);
                    }
                }

            },
            schema: {
                data: function (response) {
                    var portalTypes = { Administration: 1, ACM: 2, SUPO: 3, ModuleManagement: 4, DSLBuilder: 5, ComplianceCentral: 6, AAIM: 7, AssentU: 8, ACP: 9 };

                    for (var i = 0; i < response.data.length; i++) {

                        if (response.data[i].portalTypeId === portalTypes.ACM) {
                            response.data[i].baseUri += '/' + $scope.targetPage;
                        } else if (response.data[i].portalTypeId === portalTypes.Administration || response.data[i].portalTypeId === portalTypes.ACP) {
                            response.data[i].baseUri += response.data[i].homePageRelativeUri;
                        }
                    }

                    return response.data;
                },
                total: 'total'
            },

            pageSize: 20,
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            sort: {
                field: 'portalName',
                dir: 'asc'
            }
        });

        var init = function () {

            if ($location.search().pg == 'undefined' || typeof ($location.search().pg) == 'undefined') {
                $scope.targetPage = '';
            } else {
                $scope.targetPage = $location.search().pg;
            }

        };

        init();
    };
})();
